import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageContainer } from '@/components/layout/PageContainer';
import { supabase } from '@/lib/supabase';
import { Toast } from '@/components/common/Toast';

export function FindIdPage() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [foundEmail, setFoundEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [toast, setToast] = useState<{ show: boolean; message: string }>({ show: false, message: '' });


  const handleBack = () => {
    navigate(-1);
  };

  const handleFindId = async () => {
    if (!name || !phone) {
      setToast({ show: true, message: '이름과 전화번호를 모두 입력해주세요' });
      return;
    }

    setIsLoading(true);
    try {
      // 전화번호와 이름으로 사용자 찾기
      const { data, error } = await supabase
        .from('users')
        .select('email')
        .eq('phone', phone)
        .eq('name', name)
        .single();

      if (error || !data) {
        setToast({ show: true, message: '일치하는 사용자 정보를 찾을 수 없습니다' });
        setFoundEmail('');
      } else {
        // 이메일 마스킹 처리
        const email = data.email;
        const [localPart, domain] = email.split('@');
        const maskedLocal = localPart.length > 3 
          ? localPart.substring(0, 3) + '*'.repeat(localPart.length - 3)
          : '*'.repeat(localPart.length);
        const maskedEmail = `${maskedLocal}@${domain}`;
        
        setFoundEmail(maskedEmail);
        setToast({ show: true, message: '아이디를 찾았습니다!' });
      }
    } catch (error) {
      setToast({ show: true, message: '아이디 찾기 중 오류가 발생했습니다' });
      setFoundEmail('');
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoToLogin = () => {
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-white">
      <PageContainer>
        {/* 헤더 */}
        <div className="flex items-center justify-center relative mb-12">
          <button
            onClick={handleBack}
            className="absolute left-0 p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <img
              src="/icons/icon_back.svg"
              alt="뒤로가기"
              className="w-6 h-6"
            />
          </button>
          <h1 className="text-2xl font-bold text-[#222222]">아이디 찾기</h1>
        </div>

        {/* 입력 폼 */}
        <div className="max-w-[280px] mx-auto space-y-8">
          {/* 이름 입력 */}
          <div>
            <label className="block text-base font-medium text-[#222222] mb-1">
              이름
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="이름을 입력해주세요"
              className="w-full h-[32px] px-3 text-base bg-[#F5F5F5] border-[1.5px] border-[#51C854] rounded-lg focus:outline-none placeholder:text-[#606060]"
            />
          </div>

          {/* 전화번호 입력 */}
          <div>
            <label className="block text-base font-medium text-[#222222] mb-1">
              전화번호(번호만 입력)
            </label>
            <input
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value.replace(/[^0-9]/g, ''))}
              placeholder="예시) 01011111111"
              className="w-full h-[32px] px-3 text-base bg-[#F5F5F5] border-[1.5px] border-[#51C854] rounded-lg focus:outline-none placeholder:text-[#606060]"
            />
          </div>

          {/* 작성 완료 버튼 */}
          <button
            onClick={handleFindId}
            disabled={isLoading}
            className="w-full h-[31px] bg-[#DEDEDE] text-[#222222] font-semibold text-xl rounded-xl hover:bg-[#CECECE] transition-colors disabled:opacity-50"
          >
            {isLoading ? '찾는 중...' : '작성 완료'}
          </button>
        </div>

        {/* 결과 출력 */}
        {foundEmail && (
          <div className="max-w-[360px] mx-auto mt-16 text-center">
            <p className="text-base font-medium text-[#000000] mb-8">
              사용자님의 아이디는 {foundEmail} 입니다
            </p>
            
            <button
              onClick={handleGoToLogin}
              className="w-full h-[31px] bg-[#DEDEDE] text-[#222222] font-semibold text-xl rounded-xl hover:bg-[#CECECE] transition-colors"
            >
              로그인 페이지로
            </button>
          </div>
        )}
      </PageContainer>

      {/* 토스트 메시지 */}
      {toast.show && (
        <Toast
          message={toast.message}
          isVisible={toast.show}
          onClose={() => setToast({ show: false, message: '' })}
        />
      )}
    </div>
  );
}